import { motion } from "framer-motion";
import cardImgBack from "../../assets/images/image4.jpg";
import cardImgMid from "../../assets/images/image6.jpg";
import cardImgTop from "../../assets/images/image9.jpg";

export default function Trainings() {
const containerVariant = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
    },
  },
};

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

const floatCard = {
  initial: { y: 0 },
  animate: {
    y: [0, -10, 0],
    transition: {
      duration: 4,
      repeat: Infinity,
      ease: "easeInOut",
    },
  },
};
const stackHoverContainer = {
  rest: {},
  hover: {},
};

const backCardRow = {
  rest: {
    x: 0,
    scale: 1,
    rotate: 0,
  },
  hover: {
    x: -160,
    scale: 1.05,
    rotate: -4,
    transition: { type: "spring", stiffness: 160, damping: 18 },
  },
};

const midCardRow = {
  rest: {
    x: 0,
    scale: 1,
    rotate: 0,
  },
  hover: {
    x: 0,
    scale: 1.08,
    rotate: 0,
    transition: { type: "spring", stiffness: 180, damping: 18 },
  },
};

const topCardRow = {
  rest: {
    x: 0,
    scale: 1,
    rotate: 0,
  },
  hover: {
    x: 160,
    scale: 1.05,
    rotate: 4,
    transition: { type: "spring", stiffness: 160, damping: 18 },
  },
};

  return (
    <section id="faqs" className="relative isolate ">

      {/* CONTENT */}
      <div className="relative z-10 pb-10 bg-[#05060a]/10 backdrop-blur-md px-10 py-20">
       {/* subtle gradient / blur background */}
        <div className="pointer-events-none absolute inset-0">
            <div className="absolute -top-32 -left-40 h-80 w-80 rounded-full bg-gray-200/10 blur-3xl" />
            <div className="absolute bottom-0 right-0 h-96 w-96 rounded-full bg-gray-200/10 blur-3xl" />
        </div>
        <section className="relative w-full overflow-hidden  text-white">
       

        <div className="relative z-10 mx-auto  max-w-6xl  px-auto py-10 ">

            {/* Main 3-column hero */}
            <motion.div
            variants={containerVariant}
            initial="hidden"
            animate="visible"
            className="grid items-center gap-10 md:grid-cols-3"
            >
            {/* LEFT TEXT */}
            <div className="space-y-6">
                <motion.div variants={fadeUp} className="inline-flex items-center gap-2 rounded-full border border-white/10 px-3 py-1 text-xs uppercase tracking-[0.25em] text-zinc-300/80">
                <span className="h-1.5 w-1.5 rounded-full bg-emerald-400" />
                Non-Profit Training Initiative
                </motion.div>

                <motion.h1
                variants={fadeUp}
                className="text-3xl font-semibold tracking-tight text-zinc-50 sm:text-4xl md:text-[2.8rem] md:leading-[1.1]"
                >
                Building climbers{" "}
                <span className="text-zinc-400">who are skilled,</span>{" "}
                <span className="bg-gradient-to-r from-zinc-100 to-zinc-400 bg-clip-text text-transparent">
                disciplined & safe.
                </span>
                </motion.h1>

                <motion.p
                variants={fadeUp}
                className="max-w-md text-sm leading-relaxed text-zinc-400"
                >
                Our training programs are designed to prepare you
                for real-world environments and real challenges. Each program focuses on
                practical skills, helping you build decision-making under pressure.

                </motion.p>

                {/* <motion.div
                variants={fadeUp}
                className="flex flex-wrap items-center gap-3 pt-2"
                >
                <button className="rounded-full border border-white/15 bg-white text-xs font-medium text-black px-4 py-2 hover:bg-zinc-100 transition">
                    Join the Program
                </button>
                <button className="rounded-full border border-white/15 px-4 py-2 text-xs text-zinc-200 hover:bg-white/5 transition">
                    View Training Vision
                </button>
                </motion.div> */}
            </div>

                {/* CENTER CARD STACK */}
            <motion.div
              variants={stackHoverContainer}
              initial="rest"
              whileHover="hover"
              animate="rest"
              className="relative z-20 isolate flex items-center justify-center"
            >

              {/* glow circle */}
              <div className="absolute h-64 w-64 rounded-full bg-purple-500/20 blur-3xl" />

              <div className="relative h-[320px] w-full max-w-[260px] sm:h-[360px] sm:max-w-[280px]">

                            {/* BACK CARD */}
                        <motion.div
                          variants={backCardRow}
                          className="absolute inset-0 overflow-hidden rounded-3xl border border-white/10 shadow-2xl shadow-black/60"
                          {...floatCard}
                        >
                          {/* background image */}
                          <div
                            className="absolute inset-0 bg-cover bg-center"
                            style={{ backgroundImage: `url(${cardImgBack})` }}
                          />
                          {/* dark overlay */}
                          <div className="absolute inset-0 bg-gradient-to-b from-black/40 to-black/80" />

                          {/* content */}
                          <div className="relative z-10 flex h-full flex-col justify-between p-4">
                            <div className="flex items-center justify-between text-[10px] text-zinc-300">
                              <span>BBCA Training</span>
                              <span>Phase 01</span>
                            </div>
                            <div className="space-y-2">
                              <div className="h-1.5 w-2/3 rounded-full bg-zinc-400/60" />
                              <div className="h-1.5 w-1/2 rounded-full bg-zinc-500/60" />
                            </div>
                          </div>
                        </motion.div>


                            {/* MID CARD */}
                        <motion.div
                          variants={midCardRow}
                          className="absolute inset-0 translate-x-4 translate-y-4 overflow-hidden rounded-3xl border border-white/20 shadow-2xl shadow-black/70"
                          {...floatCard}
                        >
                          {/* background image */}
                          <div
                            className="absolute inset-0 bg-cover bg-center"
                            style={{ backgroundImage: `url(${cardImgMid})` }}
                          />
                          {/* dark overlay */}
                          <div className="absolute inset-0 bg-gradient-to-b from-black/30 to-black/85" />

                          {/* content */}
                          <div className="relative z-10 flex h-full flex-col justify-between p-5">
                            <div className="flex items-center justify-between text-[10px] uppercase tracking-[0.18em] text-zinc-300">
                              <span>Boot Camp Program</span>
                              <span>↗</span>
                            </div>

                            <div className="space-y-4">
                              <div className="space-y-1.5">
                                <div className="h-1.5 w-3/4 rounded-full bg-zinc-200/80" />
                                <div className="h-1.5 w-1/2 rounded-full bg-zinc-400/80" />
                              </div>

                              <div className="grid grid-cols-2 gap-2 text-[10px] text-zinc-300">
                                <div className="rounded-xl border border-white/10 bg-black/40 p-2">
                                  <div className="mb-1 h-1 w-6 rounded-full bg-zinc-400" />
                                  <p>Physical Training</p>
                                </div>
                                <div className="rounded-xl border border-white/10 bg-black/40 p-2">
                                  <div className="mb-1 h-1 w-6 rounded-full bg-zinc-400" />
                                  <p>Technical Skill</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </motion.div>


                            {/* TOP CARD */}
                        <motion.div
                          variants={topCardRow}
                          className="absolute inset-0 -translate-x-3 -translate-y-4 overflow-hidden rounded-3xl border border-white/20 shadow-[0_40px_120px_rgba(0,0,0,0.7)]"
                        >
                          {/* background image */}
                          <div
                            className="absolute inset-0 bg-cover bg-center"
                            style={{ backgroundImage: `url(${cardImgTop})` }}
                          />
                          {/* dark overlay */}
                          <div className="absolute inset-0 bg-gradient-to-b from-black/20 to-black/90" />

                          {/* content */}
                          <div className="relative z-10 flex h-full flex-col justify-between p-5">
                            <div className="flex items-center justify-between text-[11px] font-medium text-zinc-200">
                              <span>Technical Climbing</span>
                              <span className="rounded-full bg-black/40 px-2 py-0.5 text-[10px]">
                                Live
                              </span>
                            </div>

                            <div className="space-y-3 pt-4">
                              <div className="h-1.5 w-2/3 rounded-full bg-zinc-200/70" />
                              <div className="h-1.5 w-1/2 rounded-full bg-zinc-300/70" />
                              {/* <div className="mt-3 h-36 rounded-2xl bg-black/40" /> */}
                            </div>

                            <div className="mt-4 flex items-center justify-between text-[10px] text-zinc-300">
                              <span>Discipline · Safety · Growth</span>
                            </div>
                          </div>
                        </motion.div>

                          </div>
                        </motion.div>


            {/* RIGHT TEXT / STATS */}
            <div className="space-y-6 md:pl-6">
                 <div className="mb-8 flex items-center justify-between text-sm text-zinc-400">
            <span className="tracking-[0.3em] uppercase">BroadBoy Climbing Academy</span>
            </div>
                <motion.div variants={fadeUp} className="space-y-2 text-right md:text-left">
                <p className="text-xs uppercase tracking-[0.25em] text-zinc-500">
                    Built for real mountains
                </p>
                <p className="text-sm text-zinc-400">
                  Our programs lay the foundation for a long-term climbing ecosystem,
                developing future guides, reducing mountain fatalities, and creating
                global representation for Pakistani climbers.

                </p>
                </motion.div>

                <motion.div
                variants={fadeUp}
                className="flex flex-col gap-4 pt-2 text-sm text-zinc-300"
                >
                <div className="flex items-baseline justify-between border-b border-white/5 pb-3">
                    <span className="text-xs uppercase tracking-[0.2em] text-zinc-300">
                    Training with Professionals
                    </span>
      
                </div>
                <div className="flex items-baseline justify-between border-b border-white/5 pb-3">
                    <span className="text-xs uppercase tracking-[0.2em] text-zinc-300">
                    Core Skill Coverage: Physical · Technical · Mental
                    </span>
                    <span className="text-sm text-zinc-100"></span>
                </div>
                <div className="flex items-baseline justify-between">
                    <span className="text-xs uppercase tracking-[0.2em] text-zinc-300">
                    Participants: Youth · Local Porters
                    </span>
                </div>
                </motion.div>
            </div>
            </motion.div>
                    
                <motion.div
                variants={fadeUp}
                className="flex justify-center items-center gap-4 pt-10 text-[12px] text-zinc-500"
                >
                <div className="flex flex-col">
                    <span className="font-medium text-zinc-300">High Altitude</span>
                    <span>Physical + Technical Training</span>
                </div>
                <div className="h-8 w-px bg-white/10" />
                <div className="flex flex-col">
                    <span className="font-medium text-zinc-300">
                    Youth & Porters
                    </span>
                    <span>Equal access & opportunity</span>
                </div>
                </motion.div>
        </div>

        </section>
      </div>
    </section>
  );
}
